if (!customElements.get("card-slider")) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions =
        JSON.parse(this.getAttribute("data-swiper-options")) || {};

      this.initSlider(swiperOptions);

      if (this.classList.contains("js-testimonials")) {
        window.addEventListener("resize", () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider.params.effect === "slide";

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        });
      }
    }

    reInitSlider(swiperOptions) {
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      console.log("init");
      let sliderOptions = {
        slidesPerView: "auto",
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        resistanceRatio: 0.72,
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev",
        },
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
          },
        },
      };

      const isArticlesSlider = this.classList.contains("js-articles");

      if (isArticlesSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 2,
        };
      } else if (this.classList.contains("js-testimonials")) {
        if (window.innerWidth < mobileWidth) {
          sliderOptions.breakpoints[0] = {
            slidesPerView: 2.1,
            spaceBetween: swiperOptions.spaceBetweenMobile || 4,
            navigation: {
              nextEl: ".testi__swiper-button--next",
              prevEl: ".testi__swiper-button--prev",
            },
            loop: true,
          };
          sliderOptions.breakpoints[480] = {
            slidesPerView: 2.3,
            spaceBetween: swiperOptions.spaceBetweenMobile || 4,
            navigation: {
              nextEl: ".testi__swiper-button--next",
              prevEl: ".testi__swiper-button--prev",
            },
            loop: true,
          };
          sliderOptions.breakpoints[750] = {
            slidesPerView: 2.3,
            spaceBetween: swiperOptions.spaceBetweenMobile || 4,
            navigation: {
              nextEl: ".testi__swiper-button--next",
              prevEl: ".testi__swiper-button--prev",
            },
            loop: true,
          };
        } else {
          sliderOptions = {
            effect: "slide",
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 8,
            loop: true,
            navigation: {
              nextEl: ".testi__swiper-button--next",
              prevEl: ".testi__swiper-button--prev",
            },
          };
        }
      }

      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define("card-slider", CardSlider);
}
